import {inject, Injectable} from '@angular/core';
import {DataUpdateService} from "./data-update.service";
import {PwaService} from "./pwa.service";
import {isNative} from "../utils";
import {App} from "@capacitor/app";
import {SplashScreen} from "@capacitor/splash-screen";

@Injectable({
  providedIn: 'root'
})
export class ResumeService {
  private readonly dataUpdateService = inject(DataUpdateService);
  private readonly pwaService = inject(PwaService);
  private hasHiddenSplash = false;

  public initialize() {
    console.log("Data update complete")
    this.update();
    App.addListener('resume', () => {
      this.update();
    });
  }

  private async update() {
    if (!isNative) {
      await this.pwaService.checkForUpdates();
    }
    await this.dataUpdateService.updateData();
    console.log("Data update complete")

    if(isNative) {
      await SplashScreen.hide();
      console.log("Splash screen hidden")
    }
  }
}
